import { Dispatch, SetStateAction, useCallback } from 'react';
import { SortDirection as MuiSortDirection } from '@mui/material';

import { ListTable } from '@atom/mui';
import colors from '@atom/styles/colors';
import { UserUserGroup } from '@atom/types/userGroups';

import UserGroupsRow from './UserGroupsRow';

import classes from './groupsTab.module.css';

const {
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  TablePagination,
} = ListTable;

type SortField = 'name' | 'addedOn';
type SortDirection = 'asc' | 'desc';

interface Props {
  groups: UserUserGroup[];
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  limit: number;
  setLimit: Dispatch<SetStateAction<number>>;
  sortDirection: MuiSortDirection;
  setSortDirection: Dispatch<SetStateAction<MuiSortDirection>>;
  sortBy: string;
  setSortBy: Dispatch<SetStateAction<string>>;
  totalCount: number;
  handleRefetch: () => void;
}

const UserGroupsTable = ({
  groups,
  page,
  setPage,
  limit,
  setLimit,
  sortDirection,
  setSortDirection,
  sortBy,
  setSortBy,
  totalCount,
  handleRefetch,
}: Props) => {
  const getSortDirection = useCallback(
    (field: SortField) => {
      if (sortBy !== field) {
        return false;
      }

      return sortDirection;
    },
    [sortBy, sortDirection],
  );

  const handleSortDirectionChange =
    (field: SortField) => (direction: SortDirection) => {
      setSortBy(field);
      setSortDirection(direction);
    };

  return (
    <ListTable className={classes.tablePad} offsetTop="272px">
      <TableHead>
        <TableRow header>
          <TableCell
            variant="head"
            sortDirection={getSortDirection('name')}
            onSortChange={handleSortDirectionChange('name')}
          >
            Name
          </TableCell>
          <TableCell variant="head">Added By</TableCell>
          <TableCell variant="head">Added On</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {groups.map(group => (
          <UserGroupsRow
            key={group.id}
            group={group}
            handleRefetch={handleRefetch}
          />
        ))}
      </TableBody>
      <TableFooter
        style={{
          border: `1px solid ${colors.neutral.ash}`,
          width: '69.9%',
        }}
      >
        <TableRow hover={false}>
          <TablePagination
            style={{ border: 'none' }}
            rowsPerPageOptions={[25, 50, 100, 250]}
            count={totalCount}
            rowsPerPage={limit}
            page={page}
            onPageChange={pageData => setPage(pageData)}
            onRowsPerPageChange={event => {
              setLimit(+event.target.value);
              setPage(1);
            }}
          />
        </TableRow>
      </TableFooter>
    </ListTable>
  );
};

export default UserGroupsTable;
